import styled, { css } from 'styled-components';
import { NavigateNextIcon as UnstyledNavigateNextIcon } from 'components/icons';
import { colors } from '@alixpartners/ui-components';

export const CenterWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 64px 32px 32px 50px;
	border-width: 1px 1px 0 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	background-color: white;
	border-radius: 3px 3px 0 0;
`;

export const ListText = styled.span`
	padding: 0 6px;
	transition: all 0.25s;
	white-space: nowrap;
`;

export const List = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`;

export const ListItem = styled.div`
	display: flex;
	color: ${colors.grey4};
	align-items: center;
	font-weight: 500;
	font-size: 19px;
	line-height: 40px;
	&:first-child {
		${ListText} {
			padding-left: 0;
		}

		svg {
			display: none;
		}
	}
	&:last-child {
		${ListText} {
			padding-right: 0;
		}
	}

	${({ active }) =>
		active &&
		css`
			${ListText} {
				color: ${colors.green1};
			}
		`};

	${({ passed }) =>
		passed &&
		css`
			${ListText} {
				color: ${colors.grey8};
			}
		`};

	${({ isFailed }) =>
		isFailed &&
		css`
			${ListText} {
				color: ${colors.amber};
			}
		`};

	${({ onClick }) =>
		onClick
			? css`
					${ListText} {
						color: ${colors.grey8};
						&:hover {
							color: ${colors.green2};
						}
					}
					cursor: pointer;
			  `
			: null};
`;

export const NavigateNextIcon = styled(UnstyledNavigateNextIcon)`
	fill: ${colors.grey5};
	width: 24px;
	height: 24px;
`;
